// Modules
import { CommonModule } from '@angular/common';
import { SingleDatePickerModule } from '../single-date-picker/single-date-picker.module';
import * as i0 from "@angular/core";
export class DateRangeModule {
}
DateRangeModule.ɵfac = function DateRangeModule_Factory(t) { return new (t || DateRangeModule)(); };
DateRangeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DateRangeModule });
DateRangeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, SingleDatePickerModule] });
